import React, { useCallback, useMemo, useState } from 'react';
import { useMount } from 'ahooks';
import { useSelector } from 'react-redux';
import { useNav } from '@/hooks';
import { ALL_PAGES, storagePrefixV2 } from '@/constant';
import { selectedCurrentCustomer } from '@/store/customer';
import service from '@/service';
import { Header, HeaderMemberInfo, SlideSelect } from '@/components';
import WeightLoss from './WeightLoss';
import BodyPainAdjust from './body-pain-adjust';
import { BodyAdjustOperateTexts, BodyChange3DContext, WeightLossOperateTexts } from './utils';

import cx from './index.module.scss';

interface Props {}

const BodyChange3D: React.FC<Props> = () => {
  const nav = useNav();
  const [tabValue, setTabValue] = useState<'weightLoss' | 'adjust'>('weightLoss');
  const currentCustomer = useSelector(selectedCurrentCustomer);
  const [bodyChangeInfo, setBodyChangeInfo] = useState<GetBodyChangeResponse>({} as any);
  const [sliderSteps, setSliderSteps] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const currentIsEmptyData = useMemo(
    () => !(bodyChangeInfo?.painReliefList?.length || bodyChangeInfo?.weightLossList?.length),
    [bodyChangeInfo]
  );

  const weightLossDescText = useMemo(() => WeightLossOperateTexts[Math.floor(Math.random() * 2)], []);
  const bodyAdjustDescText = useMemo(() => BodyAdjustOperateTexts[Math.floor(Math.random() * 2)], []);

  const getServiceCustomerInfo = useCallback(async () => {
    if (!currentCustomer.customerId) return;

    try {
      const { data } = await service.customer.getBodyChange(currentCustomer?.customerId);
      setBodyChangeInfo(data || ({} as any));

      const steps = [];

      if (data?.weightLossList?.length) {
        steps.push({ value: 'weightLoss', label: '减肥瘦身' });
      } else {
        setTabValue('adjust');
      }

      if (data?.painReliefList?.length) {
        steps.push({ value: 'adjust', label: '体态&痛症调整' });
      }

      setSliderSteps(steps);
    } finally {
      setIsLoading(false);
    }
  }, [currentCustomer?.customerId]);

  useMount(getServiceCustomerInfo);

  return (
    <div className={cx('BodyChange3D')}>
      <BodyChange3DContext.Provider value={{ bodyChangeInfo, weightLossDescText, bodyAdjustDescText }}>
        <Header
          title={<HeaderMemberInfo textContent="的身体记录详情" />}
          backConfig={{
            text: '会员详情',
            action: () => nav(ALL_PAGES.MEMBER_DETAIL, { state: { currentIsExpand: true } }),
          }}
        />
        {isLoading ? null : currentIsEmptyData ? (
          <div className={cx('empty-data')}>
            <img src={storagePrefixV2 + '/jqiwfjasdfasf.png'} alt="" />
          </div>
        ) : (
          !!sliderSteps?.length && (
            <>
              <SlideSelect
                activeColor="lightBlue"
                className={cx('slider')}
                steps={sliderSteps}
                value={tabValue}
                onChange={value => setTabValue(value as any)}
              />
              <div className={cx('main-content-wrapper')}>
                {tabValue === 'weightLoss' ? <WeightLoss /> : <BodyPainAdjust />}
              </div>
            </>
          )
        )}
      </BodyChange3DContext.Provider>
    </div>
  );
};

export default BodyChange3D;
